var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AlertDismiss',{ref:"alertDismiss",staticClass:"mx-2"}),(_vm.load)?_c('LoadCard'):_c('Bar',{ref:"barChart",attrs:{"data":_vm.datacollection,"options":_vm.options,"width":_vm.width,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }